import PricingCard from "@components/BasicComponents/Cards/PricingCard/PricingCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import CustomSelect, {
	option,
} from "@components/Theme/Select/CustomSelect/CustomSelect"
import {Currencies} from "@config/currencies"
import {translate} from "@helpers/translate"
import {
	AdvancedSideAssetModuleType,
	PricingCardModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import styles from "./PackagesSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	cards: PricingCardModuleType[]
}

const PackagesSection = (props: Props) => {
	const currencies = Currencies()

	const [activeCurrency, setActiveCurrency] = useState<string>("eur")

	const handleSelect = (selectedOptions: {[key: string]: string[]}) => {
		setActiveCurrency(selectedOptions.currencies?.[0])
	}

	const currencyActive = currencies.find(
		(element: option) => element.slug === activeCurrency,
	)

	const {locale} = useLocale()

	return (
		<section id={"book-a-demo"}>
			<ContainerWrapper>
				<Separator size={128}>
					<Title
						className={styles.title}
						content={props.data.sectionTitle}
						fontWeight={600}
						size={"L"}
						center
					/>
					<Separator />
					<div className={styles.currencyBox}>
						<Paragraph
							className={styles.currencyTitle}
							content={`${translate("Select Currency", locale)}:`}
							size={"M"}
						/>
						<CustomSelect
							activeValue={[activeCurrency]}
							className={styles.select}
							enableAll={false}
							name={"currencies"}
							options={currencies}
							onChange={handleSelect}
						/>
					</div>

					<Separator size={32} />
					<div className={styles.cardsContainer}>
						<PricingCard
							className={styles.card}
							color={"default"}
							currency={currencyActive}
							data={props.cards[0]}
						/>
						<PricingCard
							className={styles.card}
							color={"default"}
							currency={currencyActive}
							data={props.cards[1]}
						/>
						<PricingCard
							className={styles.card}
							color={"main"}
							currency={currencyActive}
							data={props.cards[2]}
						/>
						<PricingCard
							className={styles.card}
							color={"default"}
							currency={currencyActive}
							data={props.cards[3]}
						/>
					</div>
					<Paragraph
						className={styles.packagesDesc}
						content={props.data.sectionBottomTitle}
						size={"XS"}
					/>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default PackagesSection
